import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { logout } from 'store/services/auth/authSlice';

export const TokenValidator = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.auth?.token);

  useEffect(() => {
    if (token) {
      // Parse JWT to check expiration
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expirationTime = payload.exp * 1000; // Convert to milliseconds
        const currentTime = Date.now();
        
        if (currentTime >= expirationTime) {
          // Token expired, clear silently
          dispatch(logout());
        }
      } catch (error) {
        // Invalid token, clear silently
        dispatch(logout());
      }
    }
  }, [token, dispatch]);

  return <>{children}</>;
};